import { Skeleton } from '../Skeleton'

interface SkeletonListRowsProps {
  count?: number
}

// Mirrors `.st-row` head: 3px ink border, var(--shadow), 16px 18px padding,
// 21px display title (~24px line) + 11px mono sub (~15px line) + 3px gap.
// Total head = 32px padding + 42px content ≈ 74px.
export function SkeletonListRows({ count = 4 }: SkeletonListRowsProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          style={{
            border: 'var(--border) solid var(--ink)',
            background: 'var(--paper)',
            boxShadow: 'var(--shadow)',
            padding: '16px 18px',
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto auto',
            gap: 16,
            alignItems: 'center',
            minHeight: 74
          }}>
          <Skeleton.Bar w={68} h={24} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 }}>
            <Skeleton.Bar w="72%" h={24} />
            <Skeleton.Bar w="38%" h={15} />
          </div>
          <Skeleton.Bar w={84} h={28} />
          <Skeleton.Bar w={22} h={22} />
        </div>
      ))}
    </div>
  )
}
